import Hero from "../components/Hero";
import Navbar from "../components/Navbar"
import PopularServices from "../components/PopularServices";
import CarImg from "../assets/PlaceHolder/12.jpg"
import Card from "../components/Card"
import Footer from "../components/Footer"
import AboutUs from "../components/AboutUs";
import Booking from "../components/Booking";
import Expertise from "../components/Expertise";
import Gallery from "../components/GalleryComponent";
import ServicesMenu from "../components/ServicesMenu";
import HomePageServicesMenu from "../components/homePageSeviceMenu";
import bannerImg from "../assets/thumb/premium_photo-1670348051093-a3f94b408bcb.avif";

// Display the navbar
// populate the hero class with detailed info
function Home (){
    return(
        <>
        <Navbar/>

        <Hero 
        cName="hero" 
        heroImg={bannerImg} 
        title="QUEEN'S NAILS & SPA"
        text="Experience Professional Nails & Spa"
        buttonText="Book an Appointment"
        //url="https://cal.com/thu-ngo-d3bs7h"
        url="/booking"
        rel="noopener noreferrer"
        btnClass="show"/>
        <AboutUs/>
        <Expertise/>        
        <PopularServices/>
        
        <HomePageServicesMenu/>
        <Footer/>
        </>
    );
}



export default Home;